
/*
* Give the container to add an overlay to -- by default call to append, then call to destroy.
* Note: assumes overlay z-index and background defined in class -- could make option to override
* Note: now has dependency on iframeShim -- if left as individual library would want to bundle the 2;
*
* */

require('jqIframeShim');

(function($) {

    $.fn.overlay = function(options) {

        var settings = {
                delay: 100,
                overlayClass: 'FV-overlay',
                opacity: 0.7,
                'z-index': 1
            },
            $win = $(window), //TODO: really want container size change -- could move to resize plugin
            $el = this;

        $.extend(settings, options);

        var $o = $('<div class="' + settings.overlayClass + '"></div>').css({
            position: 'relative', //necessary to derive z-index from class (also must append)
            display: 'none' //start hidden
        });

        this.append($o);


       $.extend( settings, {'z-index': parseFloat( $o.css('z-index') ) });

        sizeAndPosition();

        $o.fadeTo( settings.delay, settings.opacity );

        $win.on('resize scroll', sizeAndPosition); //TODO: for scroll really want the parent container if overflow --- other option is using css and ensuring has position
        this.on('overlay:close', close);

        function sizeAndPosition() {
            $o.css( cssForOverlay( $o, settings['z-index']) );
        }

        function close(e, delay) {


            $o.fadeOut( delay ? delay : 0, function() {

                $win.off( 'resize scroll', sizeAndPosition );
                $o.iframeShim('destroy');
                $o.remove(); // TODO: small memory leak here -- the ref in the size and position closure -- putting in own fn not helping

                //$o = null; -- doesn't fix mem leak
            });

        }

        /* Note: relative to window */
        function cssForOverlay(zIndex) {
            return {
                position: 'fixed', //(getting rel to document)
                'z-index': zIndex ? zIndex : parseFloat($el.css('z-index')),
                top: $el.offset().top - $(window).scrollTop(),
                left: $el.offset().left - $(window).scrollLeft(),
                width: $el.outerWidth(),
                height: $el.outerHeight()
            };
        }

        return this;

    };


})(jQuery);




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/overlay.js
 ** module id = 116
 ** module chunks = 0
 **/